import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import { useTranslations } from 'hooks/useTranslations';
import { emptyFieldHolder } from 'components/molecules/CardList';

export enum EDocumentsAttachmentsLabel {
  name = 'legalEntity.licence.documentName.label',
  weaponLicenceDocumentType = 'legalEntity.licence.documentType.label',
  comment = 'legalEntity.licence.comment.label',
}

interface IAttachmentsCard {
  data: ITableDataSource;
  handleDownload: (file: File) => void;
  handleDelete: (id: number) => void;
}

const AttachmentsCard = ({ data, handleDownload, handleDelete }: IAttachmentsCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t(EDocumentsAttachmentsLabel.name)}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.name)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t(EDocumentsAttachmentsLabel.weaponLicenceDocumentType)}
        </Typography>
        <Typography variant="body2">
          {emptyFieldHolder(data.weaponLicenceDocumentType)}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t(EDocumentsAttachmentsLabel.comment)}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.comment)}</Typography>
      </Grid>

      <Grid
        container
        size={{ xs: 12 }}
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: {
            xs: `1px solid ${colors.primary100}`,
            md: 'none',
          },
          p: 2,
        }}
      >
        <Grid size={{ xs: 12, sm: 4 }} sx={{ mb: { xs: 1, sm: 0 } }}>
          <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
            {t('legalEntity.licence.action.column')}:{' '}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 8 }} sx={{ display: 'flex', gap: 1 }}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Button
              id={`licence_details_attachment_download-button-${data.id}`}
              variant={EButtonVariants.outlined}
              label={t('legalEntityDetails.attachments.download.button')}
              onClick={() => handleDownload(data.file)}
              size={EButtonSizes.small}
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Button
              id={`licence_details_attachment_delete-button-${data.id}`}
              variant={EButtonVariants.outlined}
              label={t('legalEntityDetails.attachments.delete.button')}
              onClick={() => handleDelete && handleDelete(data.id as number)}
              size={EButtonSizes.small}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export { AttachmentsCard };
